import { Nomenclature } from 'graphql-common';
import FieldNames from '@lib/enums/fieldNames/assetNomenclatureFieldNames';

export default function getDefaultNomenclatureFormValuesFromQueryData(
  data?: Nomenclature,
) {
  return {
    [FieldNames.ComponentAsset]: data?.componentAsset
      ? {
          label: data?.componentAsset?.name,
          value: data?.componentAsset?.id,
          data: data?.componentAsset,
        }
      : null,
    [FieldNames.Quantity]: data?.quantity || null,
    [FieldNames.ComponentAssetText]: null,
  };
}
